import ButtonLink from "@components/ButtonLink";
import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import Table from "@components/Table";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import { AWARD_VIDEO } from "@constants/routes";
import useListColumns from "@hooks/Award/useListColumns";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import useListItems from "@hooks/Shared/useListItems";
import listMapper from "@mappers/Modules/award/ListAward.mapper";
import deleteAward from "@services/Award/deleteAward";
import getAwards from "@services/Award/getAwards";
import { ReactElement, useEffect, useState } from "react";
import { Container } from "reactstrap";
import styles from "./ListItems.module.scss";

const ListItems = (): ReactElement => {
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    getAwards,
    listMapper,
    isDeletingItem
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`Awards | Delete confirmation`}
        body={`Are you sure you want to remove the item:  "${basicData?.description}" ?`}
        handleConfirm={() => {
          handleDelete(deleteAward);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />
      <Title />

      <div className={styles.btnContainer}>
        <div className={styles.btnGroup}>
          <ButtonLink
            pathname={AWARD_VIDEO}
            title="Award's Video"
            className={styles.video}
          />
          <CreateBtn />
        </div>
      </div>

      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
